import React from "react";

interface ClarityIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const ClarityIcon: React.FC<ClarityIconProps> = ({ className = "", ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.38759 1.6665H11.2468L14.6673 5.83348L7.99358 14.3332L1.33398 5.8515L4.38759 1.6665ZM4.70399 2.93602L2.95023 5.33957H7.11541L4.70399 2.93602ZM5.85666 2.66825L7.97439 4.77905L9.88034 2.66825H5.85666ZM10.9905 2.93622L8.8204 5.33957H12.9633L10.9905 2.93622ZM7.99358 12.7078L2.99479 6.34131H12.9924L7.99358 12.7078Z"
      />
    </svg>
  );
};
